var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { nextTick, ref, watch } from "vue";
import IntersectionObservable from "./IntersectionObservable.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListingLayout',
    props: {
        items: null,
        queryKey: null,
        dataKey: null,
        loading: { type: Boolean },
        offset: null
    },
    emits: ["scroll"],
    setup(__props, { emit }) {
        const props = __props;
        const root = ref();
        const currentOffset = ref(0);
        watch(() => currentOffset.value, (offset) => emit("scroll", offset));
        watch(() => props.queryKey, () => {
            var _a;
            (_a = root.value) === null || _a === void 0 ? void 0 : _a.scrollTo({
                top: 0,
            });
        });
        watch(() => props.offset, (offset) => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            if (offset !== undefined) {
                scrollToOffset(offset);
            }
        }), { immediate: true });
        function scrollToOffset(offset) {
            var _a;
            const element = (_a = root.value) === null || _a === void 0 ? void 0 : _a.querySelector(`.listing-layout-item[data-index="${offset}"]`);
            element === null || element === void 0 ? void 0 : element.scrollIntoView();
        }
        const observer = new IntersectionObserver((items) => {
            const intersecting = items.filter((item) => item.isIntersecting);
            const indices = intersecting.map((item) => { var _a; return parseInt((_a = item.target.getAttribute("data-index")) !== null && _a !== void 0 ? _a : "0"); });
            currentOffset.value = indices.length > 0 ? Math.min(...indices) : 0;
        }, { root: root.value });
        function getKey(item, index) {
            if (props.dataKey) {
                return item[props.dataKey];
            }
            else {
                return index;
            }
        }
        return { __sfc: true, props, emit, root, currentOffset, scrollToOffset, observer, getKey, IntersectionObservable, LoadingSpan };
    }
});
